import React, { useState } from 'react'
import Header from '../../components/header/Header'
import Content from '../../components/content/Content'

import styles from './Home.module.scss'
import Footer from '../../components/footer/Footer'
import PreviewNav from '../../components/nav/PreviewNav'
import { PreviewNavElement } from '../../types/Types'
import PreviewViewer from '../../components/viewer/PreviewViewer'
import CircleButton from '../../components/utils/CircleButton'
import { useNavigate } from 'react-router-dom'
import MoveHeader from '../../hooks/MoveHeader'
const Home = () => {
    const navigator = useNavigate();
    const {setHeaderIndex} = MoveHeader();
    
    const [servicePreview, setServicePreview] = useState<string>("객실 제어")
    const [managePreview, setManagePreview] = useState<string>("객실 관리")

    const moveToPath = (path: string, headerIndex: number) => {
        setHeaderIndex(headerIndex);
        navigator(path);
    }

    const chageServicePreview = (name:string) => {
        setServicePreview(name);
    }

    const chageManagePreview = (name:string) => {
        setManagePreview(name);
    }

    const moveTop = () => {
        window.scrollTo(0, 0);
    }

    return (
        <div >
            <CircleButton onClick={moveTop} />
            <Content>
                <div className={styles.banner}>
                    <div className={styles.comment} />
                    <div className={styles.comment_sub} />
                </div>
                <div className={styles.article}>
                    <div className={styles.section}>
                        <div className={'H1 extrabold'}>세상의 기술은 계속 발전합니다</div>
                        <div className={`${styles.comment} body1 medium mgt16`}>
                            기술이 발전함에 따라 라이프스타일 또한 변화해야 합니다.<br/>
                            그러나 숙박업 분야는 과거에 고착되어 있는 상태입니다.
                        </div>
                        <div className={`${styles.comment_box_wrap} mgt80`}>
                            <div className={styles.comment_box}>
                                <div className={`${styles.title} title1 bold wh`}>
                                    가계소비 감소 전망,<br/>
                                    숙박업에 주는 영향 있어
                                </div>
                                <div className={`${styles.comment} body2 medium wh`}>
                                    경기침체 회복에 긴 시간이 소요될 것으로 전망되어 외부 활동에 대한 소비계획이 1차적으로 축소되고 있다. 이젠 숙박업계도 경쟁력을 키워 돌파구를 마련해야 한다.
                                </div>
                            </div>
                            <div className={styles.comment_box}>
                                <div className={`${styles.title} title1 bold wh`}>
                                    서비스 직종인데도 서비스 질이<br/>
                                    떨어지는 숙박업의 현실
                                </div>
                                <div className={`${styles.comment} body2 medium wh`}>온라인의 발달로 접근성과 가격이 편리해졌음에 비해 숙박업의 질도 높아져야 하지만 그렇지 않기에 중소형 숙박 시장을 부정적으로 바라보는것으로 예상한다.</div>
                            </div>
                            <div className={styles.comment_box}>
                                <div className={`${styles.title} title1 bold wh`}>
                                    디지털 전환,<br/>
                                    선택이 아닌 생존의 과제
                                </div>
                                <div className={`${styles.comment} body2 medium wh`}>오프라인에서 온라인, 콘택트에서 온택트로 전환되는 시대에 디지털 전환을 시도하고 싶지만 어디서부터 어떻게 시도해야할지 막막한 점주들이 많다.</div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.section}>
                        <div className={`${styles.sub_img} H2 bold`}>
                            숙박업 디지털 전환의 본격 시작을<br/>
                            똑똑과 함께 시작해보세요
                        </div>
                    </div>
                    <div className={styles.section}>
                        <div className={`${styles.platform_explane_box}`}>
                            <div className={styles.explane_comment_box}>
                                <div className={`H1 extrabold`}>
                                    고객과 호텔을 연결하는<br/>
                                    SMART PLATFORM
                                </div>
                                <div className={`body1 medium mgt40`}>
                                    똑똑은 호텔에서 제공하는 서비스를 비대면으로 신속하게 진행할 수<br/>
                                    있으며 객실 환경을 제어할 수 있는 스마트 운영 솔루션입니다.
                                </div>
                            </div>
                            <div className={styles.platform_img}></div>
                        </div>
                    </div>
                    <div className={styles.section}>
                        <div className={styles.preview_box}>
                            <div className='H2 bold mgt160'>방문 고객용 똑똑</div>
                            <PreviewNav onTabName={chageServicePreview} els={['객실 제어', '어메니티', '룸서비스', 'FAQ', '프론트 문의', '출차 요청', '1:1 채팅문의']} type={"service"}/>
                            <PreviewViewer viewerName={servicePreview} type={"service"}/>
                            <div className='H2 bold mgt80'>매장 관리자용 똑똑</div>
                            <PreviewNav onTabName={chageManagePreview} els={['객실 관리', '어메니티 관리', '룸서비스 관리', '컨시어지', '출차 관리', '1:1 채팅문의']} type={"manage"}/>
                            <PreviewViewer viewerName={managePreview} type={"manage"}/>
                        </div>
                    </div>
                    <div className={styles.section}>
                        <div className={`${styles.experience_box}`}>
                            <div className={`${styles.experience_title} H1 extrabold`}>
                                똑똑과 함께하는 변화<br/>
                                직접 경험해보세요
                            </div>
                            <div className={styles.experience_img}>
                                <div className={styles.improve} />
                                <div className={styles.product} />
                                <div className={styles.reduce} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.section}>
                        <div className={styles.reduce_box}>
                            <div className={styles.reason_box}>
                                <div className='H1 extrabold'>
                                    똑똑은 점주님의<br/>
                                    부담을 덜어드립니다
                                </div>
                                <ul className={`${styles.reson_detail} body1 medium mgt40`}>
                                    <li><div className={styles.check_icon}/>서비스 도입을 위한 확실한 케어과정으로 서비스 만족도가 상승합니다.</li>
                                    <li><div className={styles.check_icon}/>초기 투자비용 약 0원! 스마트호텔 도입에 대한 비용부담을 줄입니다.</li>
                                    <li><div className={styles.check_icon}/>간단한 교육 이후 스마트호텔로 전환이 가능합니다.</li>
                                    <li><div className={styles.check_icon}/>초기 투자 비용이 적기 때문에 입문하는 중소형 호텔에 적합합니다.</li>
                                </ul>
                            </div>
                            <div className={styles.price_img} />
                        </div>
                    </div>
                    <div className={styles.section}>
                        <div className={styles.process_box}>
                            <div className='H1 extrabold mgt120'>똑똑 단계별 프로세스</div>
                            <div className='body1 medium mgt16'>
                                도입 상담부터 운영 가이드까지<br/>
                                똑똑 단계별 프로세스로 도입을 진행합니다.
                            </div>
                            <div className={`${styles.process_img} mgt80`}>
                                <div className={styles.step1}/>
                                <div className={styles.arrow}/>
                                <div className={styles.step2}/>
                                <div className={styles.arrow}/>
                                <div className={styles.step3}/>
                            </div>
                        </div>
                    </div>
                    <div className={styles.section}>
                        <div className={styles.start_box}>
                            <div className='H1 extrabold mgt120'>
                                성장파트너 똑똑과 함께<br/>
                                디지털 전환을 시작해보세요      
                            </div>
                            <div className={`${styles.start_button_box} mgt40`}>
                                <div onClick={()=>{moveToPath("/experience", 1)}} className={`${styles.experience_button} body1 medium mgr24`}>체험하러 가기</div>
                                <div onClick={()=>{moveToPath("/inquire", 4)}} className={`${styles.inquire_button} body1 medium wh`}>도입 문의하기</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
            <Footer />
        </div>
    )
}

export default Home
